<ngx-guided-tour nextText="Siguiente" skipText="" backText="Anterior" doneText="Finalizar" closeText="Cerrar" ></ngx-guided-tour>
<div class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">

    <mat-drawer-container class="flex-auto sm:h-full">

        <!-- Drawer -->
        <mat-drawer
            class="sm:w-80 dark:bg-gray-900"
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            #drawer>
            <!-- Header -->
            <div class="flex items-center justify-between m-8 mr-6 sm:my-10">
                <!-- Title -->
                <div class="text-2xl font-extrabold tracking-tight leading-none">Mi cuenta</div>
                <!-- Close button -->
                <div class="lg:hidden">
                    <button
                        mat-icon-button
                        (click)="drawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    </button>
                </div>
            </div>
            <!-- Panel links -->
            <div class="flex flex-col divide-y border-t border-b">
                <button *ngIf="showTour" class="btn btn-default btn-lg" type="button" id="demo" (click)="reiniciaTour()" data-demo>Iniciar Tour</button>
                <ng-container *ngFor="let panel of panels; trackBy: trackByFn">
                    <div id="element{{panel.id}}"
                        class="flex px-8 py-5 cursor-pointer"
                        [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover': !selectedPanel || selectedPanel !== panel.id,
                                    'bg-primary-50 dark:bg-hover': selectedPanel && selectedPanel === panel.id}"
                        (click)="goToPanel(panel.id)">
                        <mat-icon
                            [ngClass]="{'text-hint': !selectedPanel || selectedPanel !== panel.id,
                                        'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id}"
                            [svgIcon]="panel.icon"></mat-icon>
                        <div class="ml-3">
                            <div
                                matTooltip="{{panel.pending ? 'Falta configuración' : ''}}"
                                class="font-medium leading-6"
                                [ngClass]="{'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id}">
                                {{panel.title}}
                                <span *ngIf="panel.pending" class="badge danger">
                                </span>
                            </div>
                            <div class="mt-0.5 text-secondary" style="font-size: 14px;">
                                {{panel.description}}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">

            <!-- Main -->
            <div class="flex-auto pt-9 pb-12" style="padding: 10px !important;">

                <!-- Panel header -->
                <div class="flex items-center">

                    <!-- Drawer toggle -->
                    <button
                        class="lg:hidden -ml-2"
                        mat-icon-button
                        (click)="drawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                    </button>

                    <!-- Panel title -->
                    <div class="ml-2 lg:ml-0 text-3xl font-bold tracking-tight leading-none">
                        {{getPanelInfo(selectedPanel)?.title}}
                    </div>
                </div>

                <!-- Load settings panel -->
                <div class="mt-8">
                    <ng-container [ngSwitch]="selectedPanel">
                        <!-- Account -->
                        <ng-container *ngSwitchCase="'account'">
                            <settings-account [idEmpresa]="idEmpresa"  [Observable$]="Observable$"></settings-account>
                        </ng-container>
                        <!-- Stamp -->
                        <ng-container *ngSwitchCase="'stamp'">
                            <settings-digital-stamp [idEmpresa]="idEmpresa" [status]="status" [Observable$]="Observable$"></settings-digital-stamp>
                        </ng-container>
                        <!-- Lugar de Expedición -->
                        <ng-container *ngSwitchCase="'place'">
                            <settings-place [idEmpresa]="idEmpresa" [Observable$]="Observable$"></settings-place>
                        </ng-container>
                        <!-- Bancos -->
                        <ng-container *ngSwitchCase="'bank'">
                            <settings-bank-account [idEmpresa]="idEmpresa"></settings-bank-account>
                        </ng-container>
                        <!-- Bancos -->
                        <ng-container *ngSwitchCase="'observacion'">
                            <settings-observations [idEmpresa]="idEmpresa"></settings-observations>
                        </ng-container>
                        
                        <ng-container *ngSwitchCase="'newEmpresa'">
                            <settings-account [idEmpresa]="0"  [Observable$]="Observable$"></settings-account>
                        </ng-container>
                        <!-- Security -->
                         <!-- <ng-container *ngSwitchCase="'security'">
                            <settings-security [idEmpresa]="idEmpresa"></settings-security>
                        </ng-container> -->
                        <!-- Plan & Billing -->
                        <ng-container *ngSwitchCase="'plan-billing'">
                            <settings-folios [idEmpresa]="idEmpresa"></settings-folios>
                        </ng-container>
                        <!-- Team -->
                        <ng-container *ngSwitchCase="'team'">
                            <settings-team [idEmpresa]="idEmpresa"></settings-team>
                        </ng-container>
                         <!-- Security -->
                         <ng-container *ngSwitchCase="'security'">
                            <settings-security [idEmpresa]="idEmpresa"></settings-security>
                        </ng-container>
                        
                    </ng-container>
                </div>

            </div>

        </mat-drawer-content>
    </mat-drawer-container>
</div>